// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-layout {
    display: flex;
    min-height: 100vh;
}

.admin-nav {
    width: 250px;
    background-color: #f8f9fa;
    padding: 20px;
    border-right: 1px solid #dee2e6;
}

.admin-nav h2 {
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #dee2e6;
}

.nav-link {
    display: block;
    padding: 12px 15px;
    color: #333;
    text-decoration: none;
    border-radius: 4px;
    margin-bottom: 8px;
    transition: all 0.3s ease;
}

.nav-link:hover {
    background-color: #e9ecef;
}

.nav-link.active {
    background-color: #007bff;
    color: white;
}

.admin-content {
    flex: 1 1;
    padding: 30px;
    background-color: #f9f9f9;
} `, "",{"version":3,"sources":["webpack://./src/components/Admin/AdminLayout.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,yBAAyB;AAC7B","sourcesContent":[".admin-layout {\n    display: flex;\n    min-height: 100vh;\n}\n\n.admin-nav {\n    width: 250px;\n    background-color: #f8f9fa;\n    padding: 20px;\n    border-right: 1px solid #dee2e6;\n}\n\n.admin-nav h2 {\n    margin-bottom: 20px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #dee2e6;\n}\n\n.nav-link {\n    display: block;\n    padding: 12px 15px;\n    color: #333;\n    text-decoration: none;\n    border-radius: 4px;\n    margin-bottom: 8px;\n    transition: all 0.3s ease;\n}\n\n.nav-link:hover {\n    background-color: #e9ecef;\n}\n\n.nav-link.active {\n    background-color: #007bff;\n    color: white;\n}\n\n.admin-content {\n    flex: 1;\n    padding: 30px;\n    background-color: #f9f9f9;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
